export default __webpack_public_path__ + "static/media/bp-2.ac48a10f.png";